import { render } from "./SuccessPaymentView.vue?vue&type=template&id=13815a49"
import script from "./SuccessPaymentView.vue?vue&type=script&lang=js"
export * from "./SuccessPaymentView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__